/**
 * Widget for CA UI Kit global error
 * 
 * Examples:
 * 
 * Custom error:
 * $(formSelector).globalError({
 *   errorMessage: 'Custom error message here'
 * })
 * 
 * Default error:
 * $(formSelector).globalError()
 */
 (function($) {
  var globalErrorElement = '<div class="ca-ui-alert flex align-items-center ca-ui-bg-danger global-error"></div>';
  var iconElement = '<i class="ca-ui-i ca-ui-i-sm ca-ui-i-alert"></i>';

  $.widget('caUi.globalError', {
    options: {
      errorMessage: 'Something went wrong. Please try again.',
      globalErrorElement: globalErrorElement,
      iconElement: iconElement
    },

    _create: function() {
      $(this.options.globalErrorElement)
        .prependTo(this.element)
        .append(this.options.iconElement)
        .append(this.options.errorMessage);
    },

    _destroy: function() {
      $('.global-error').remove();
    }
  })
})(jQuery);